/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ThreadKey } from './ThreadKey';

/**
 * One artifact rendered for the FE chat thread.
 *
 * Distinct from the LLM-prose `render_artifact_for_prompt` output — that
 * returns a single string for LLM reasoning. This is structured for a chat
 * UI: an icon, a title, optional subtitle / badges / action. `state`
 * artifacts surface as sidebar widgets; `episode` artifacts as in-thread
 * banners (open → "current", closed → a past view).
 */
export type ChatArtifactView = {
  /**
   * 'state' or 'episode' — typed Literal for FE narrowing.
   */
  kind: ChatArtifactView.kind;
  /**
   * Artifact type (e.g. 'comparison_set', 'compare')
   */
  type: string;
  /**
   * Short icon key (e.g. 'scale', 'target', 'history')
   */
  icon: string;
  /**
   * One-line display title
   */
  title: string;
  subtitle?: string | null;
  /**
   * Short tag chips (e.g. plan ids)
   */
  badges?: Array<string>;
  /**
   * Optional affordance hint: 'edit' / 'expand' / None
   */
  action?: string | null;
  /**
   * (started_at, ended_at) for episodes; None for state.
   */
  timestamps?: any[] | null;
  artifact_id: string;
  /**
   * Raw payload — exposed for power-user debug expand.
   */
  payload?: Record<string, any> | null;
  /**
   * For a subagent-output card whose reasoning is persisted (DV): the `(thread_type, thread_id)` of its sub-thread. The FE pairs this with `action='expand'` to fetch + reveal the subagent's isolated turns from the internal-only sub-thread endpoint. None for cards with no expandable sub-thread.
   */
  sub_thread?: ThreadKey | null;
};
export namespace ChatArtifactView {
  /**
   * 'state' or 'episode' — typed Literal for FE narrowing.
   */
  export enum kind {
    STATE = 'state',
    EPISODE = 'episode',
  }
}
